// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YSC7N","memberDetail":"styles_memberDetail__9AiJv"};